export default __webpack_public_path__ + "navigation-examples-route-init-thumbnail-480-04f9e718bfdeeaf25098526cb3763363.webp";